const setCompanyName = (val = null) => {
  return {
    type: 'SET_COMPANYNAME',
    data: val,
  }
}

export default {
  setCompanyName,
}
